import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";

export default function AddSubAdmin() {
    const { objectId } = useParams();
    const navigate = useNavigate();
    const [isEdit, setIsEdit] = useState(false);
    const [successMessaage, setSuccessMessage] = useState("");

    useEffect(() => {
        const objectId = window.location.pathname.split("/").pop();
        if (objectId !== 'add-subadmin') {
            setIsEdit(objectId);
        }
    }, []);
    const token = localStorage.getItem("adminToken");
    const API_URL = process.env.REACT_APP_BASE_URL_API || "";

    const [form, setForm] = useState({
        name: "",
        email: "",
        mobile: "",
        password: "",
        status: 'Deactive',
    });

    const [errors, setErrors] = useState({});

    /* ========================
       GET DATA FOR UPDATE
    ========================= */
    useEffect(() => {

        if (!isEdit) return;

        fetch(`${API_URL}/api/admin/sub-admin-single/${isEdit}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((res) => {

                if (res.status && res.data) {
                    setForm({
                        name: res.data.name || "",
                        email: res.data.email || "",
                        mobile: String(res.data.mobile) || "",
                        password: res.data.show_password ? decodeBase64(res.data.show_password) : "",
                        status: res.data.status || "Deactive",
                    });
                }
            })
            .catch(() => {
                alert("Failed to fetch data");
            });
    }, [isEdit]);

    const decodeBase64 = (str) => {
        try {
            if (!str) return "";

            // convert URL-safe base64 to normal base64
            str = str.replace(/-/g, "+").replace(/_/g, "/");

            // add padding if missing
            while (str.length % 4) {
                str += "=";
            }

            return decodeURIComponent(escape(atob(str)));
        } catch (err) {
            console.error("Base64 decode failed:", err);
            return "";
        }
    };

    /* ========================
       HANDLE CHANGE
    ========================= */
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    /* ========================
       VALIDATION
    ========================= */
    const validate = () => {
        let err = {};

        if (!form.name.trim()) err.name = "Name is required";
        if (!form.email.trim()) err.email = "Email is required";
        const mobile = String(form.mobile).trim();
        if (!mobile) {
            err.mobile = "Mobile is required";
        } else if (mobile.length !== 10) {
            err.mobile = "Mobile must be 10 digits";
        }

        if (!form.password.trim()) {
            err.password = "Password is required";
        }

        if (form.password.length < 6) {
            err.password = "Password must be at least 6 characters";
        }

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    /* ========================
       SUBMIT
    ========================= */
    const handleSubmit = () => {
        if (!validate()) return;

        const url = isEdit
            ? `/api/admin/sub-admin-list/update/${isEdit}`
            : `/api/admin/sub-admin-create`;

        fetch(`${API_URL}${url}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(form),
        })
            .then((res) => res.json())
            .then((res) => {
                if (res.status) {
                    setSuccessMessage(isEdit ? "Updated successfully" : "Added successfully");
                    navigate("/roles-permissions/view-subadmin");
                } else {
                    alert(res.message || "Something went wrong");
                }
            })
            .catch(() => {
                alert("Server error");
            });
    };

    const generatePassword = () => {
        const chars =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const length = Math.floor(Math.random() * 3) + 8; // 8, 9 or 10
        let password = "";

        for (let i = 0; i < length; i++) {
            password += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return password;
    };

    const handleGeneratePassword = () => {
        const newPassword = generatePassword();

        setForm((prev) => ({
            ...prev,
            password: newPassword,
        }));
    };
    useEffect(() => {
        handleGeneratePassword();
    }, []);


    return (
        <div className="container body">
            <div className="main_container">
                <Sidebar />
                <Header pageTitle={isEdit ? "Update Sub Admin" : "Add Sub Admin"} />

                <div className="right_col" role="main">
                    

                    <div className="x_panel">
                        <div className="x_content">
                            <div className="filtercont">
                                <div className="row">

                                    {/* NAME */}
                                    <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            value={form.name}
                                            onChange={handleChange}
                                        />
                                        <p className="text-danger">{errors.name}</p>
                                    </div>


                                    {/* EMAIL */}
                                    <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                                        <label>Email</label>
                                        <input
                                            type="text"
                                            name="email"
                                            className="form-control"
                                            value={form.email}
                                            onChange={handleChange}
                                        />
                                        <p className="text-danger">{errors.email}</p>
                                    </div>
                                    <div className="col-md-12"></div>
                                    {/* MOBILE */}
                                    <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                                        <label>Mobile</label>
                                        <input
                                            type="text"
                                            name="mobile"
                                            className="form-control"
                                            maxLength={10}
                                            value={form.mobile}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                setForm({ ...form, mobile: value });
                                            }}
                                        />

                                        <p className="text-danger">{errors.mobile}</p>
                                    </div>


                                    {/* PASSWORD */}

                                    <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                                        <label>Password</label>

                                        <div className="input-group">
                                            <input
                                                type="text"
                                                name="password"
                                                className="form-control"
                                                value={form.password}
                                                onChange={handleChange}
                                                readOnly
                                            />

                                            <button
                                                type="button"
                                                className="btn-sm btn-light"
                                                onClick={handleGeneratePassword}
                                            >
                                                <i className="fa fa-refresh"></i>
                                                Generate
                                            </button>
                                        </div>

                                        <p className="text-danger">{errors.password}</p>
                                    </div>



                                    <div className="col-md-12"></div>

                                    {/* ACTIVE */}
                                    <div className="col-12 col-sm-4 pr-lg-0">
                                        <input
                                            type="checkbox"
                                            name="status"
                                            checked={form.status === "Active"}
                                            onChange={(e) =>
                                                setForm({
                                                    ...form,
                                                    status: e.target.checked ? "Active" : "Deactive",
                                                })
                                            }
                                        />

                                        <label className="ml-2">Active</label>
                                    </div>

                                    <div className="col-md-12"></div>
                                    {/* BUTTON */}
                                    <div className="col-12 col-sm-8 pr-lg-0 text-right">
                                        <button
                                            type="button"
                                            className="btn sitebtn d-inline-block"
                                            onClick={handleSubmit}
                                        >
                                            {isEdit ? "Update" : "Submit"}
                                        </button>
                                        {successMessaage && <p className="text-success">{successMessaage}</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    );
}
